import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

import { Box } from './styles'

interface SectionProps {
	border?: boolean
	title?: string
	subtitle?: string
	children: ReactNode
}

const Section = ({
	border = true,
	title,
	subtitle,
	children,
}: SectionProps) => (
	<Box borderBottom={border ? 1 : 0}>
		{title && <Typography variant="h3">{title}</Typography>}
		{subtitle && (
			<Typography variant="body2" color="textSecondary">
				{subtitle}
			</Typography>
		)}
		<Box mt={1} mb={2}>
			{children}
		</Box>
	</Box>
)

export { Section }
